import queryString from 'query-string';

/**
 * Returns the value for the requested name in the query string
 * @param  {String} name Query String Key
 * @return {String}      Query String Value
 */
export function queryParam(name) {
  let query = queryString.parse(location.search);
  return query[name];
}

/**
 * Query string wrapper
 * @param {Object} object
 * @return {String}
 */
export function toQueryString(object) {
  return queryString.stringify(object);
}

export function getSearchParamOnPluginURL(name) {
  const searchString = window.location.hash.split('?')[1];
  const query = queryString.parse(searchString);

  let value = query[name];
  if (typeof value === 'string' && value.includes('?')) {
    value = value.split('?')[0];
  }
  return value;
}
